import { render } from "./EventsCourses.vue?vue&type=template&id=09f7b37e&scoped=true"
import script from "./EventsCourses.vue?vue&type=script&lang=js"
export * from "./EventsCourses.vue?vue&type=script&lang=js"

import "./EventsCourses.vue?vue&type=style&index=0&id=09f7b37e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f7b37e"]])

export default __exports__